import React, { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, ArrowRight, Info, Stethoscope } from "lucide-react";
import { api, formatErr } from "../../lib/api";
import { LEVEL_COLOR } from "../../lib/wellness";
import SessionView from "../SessionView";

const W_STYLE = { high: ["#f87171", AlertTriangle], health: ["#f87171", Stethoscope], info: ["#facc15", Info] };

const Gauge = ({ t }) => {
  const c = LEVEL_COLOR[t.level];
  return (
    <div style={{ flex: 1, minWidth: 160 }} data-testid="today-readiness">
      <div className="qv-overline">Tu estado hoy</div>
      <div style={{ fontFamily: "Bebas Neue", fontSize: 34, color: c, lineHeight: 1.1, marginTop: 4 }}>{t.level_label}</div>
      <div style={{ height: 6, background: "#1f1f1f", marginTop: 8 }}><div style={{ width: `${t.score}%`, height: 6, background: c, transition: "width .8s ease" }} /></div>
      <div style={{ fontSize: 11, color: "#737373", marginTop: 4 }}>Índice de bienestar {t.score}/100</div>
    </div>
  );
};

export const TodayScreen = ({ c }) => {
  const t = c.today;
  const [s, setS] = useState(null);
  const open = () => api.get(`/me/sessions/${t.session_id}`).then((r) => setS(r.data)).catch((e) => toast.error(formatErr(e)));
  return (
    <div data-testid="today-screen" style={{ animation: "fadeIn .4s ease" }}>
      {t.warnings.map((w, i) => {
        const [col, Icon] = W_STYLE[w.level];
        return <div key={i} style={{ display: "flex", gap: 10, padding: 14, marginBottom: 10, border: `1px solid ${col}66`, background: `${col}14`, color: "#fff", fontSize: 14 }} data-testid={`today-warning-${w.level}`}><Icon size={18} color={col} style={{ flexShrink: 0 }} />{w.text}</div>;
      })}
      <div className="qv-card-app" style={{ padding: 20, marginBottom: 12 }}>
        <div className="qv-overline">Hoy toca esto</div>
        <div style={{ fontSize: 17, lineHeight: 1.5, marginTop: 8 }} data-testid="today-focus">{t.focus}</div>
        <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginTop: 18 }}>
          <Gauge t={t} />
          <div style={{ minWidth: 140 }} data-testid="today-rpe">
            <div className="qv-overline">RPE objetivo</div>
            <div style={{ fontFamily: "Bebas Neue", fontSize: 54, lineHeight: 1 }}>{t.target_rpe ?? "—"}<span style={{ fontSize: 20, color: "#737373" }}>{t.target_rpe ? "/10" : ""}</span></div>
            {t.planned_rpe && t.planned_rpe !== t.target_rpe && <div style={{ fontSize: 12, color: "#a3a3a3" }}>Planificado: {t.planned_rpe}</div>}
            {t.target_rpe && t.rpe_provisional && <div style={{ fontSize: 11, color: "#737373" }}>Estimación orientativa</div>}
          </div>
        </div>
      </div>
      <div className="qv-card-app" style={{ padding: 16, marginBottom: 12, fontSize: 14 }} data-testid="today-adjustments">
        <div className="qv-overline" style={{ marginBottom: 8 }}>Cambios en tu sesión</div>
        {t.adjustments.length ? t.adjustments.map((a, i) => <div key={i}>{a.text}</div>) : <div style={{ color: "#d4d4d4" }}>{t.adjustments_note}</div>}
        {t.reason && <div style={{ marginTop: 10, color: "#a3a3a3" }} data-testid="today-reason"><b style={{ color: "#fff" }}>Motivo: </b>{t.reason}</div>}
      </div>
      {t.other_adjusted?.length > 0 && <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 12 }} data-testid="today-other-adjusted">También hemos suavizado {t.other_adjusted.length} sesión{t.other_adjusted.length > 1 ? "es" : ""} de los próximos días ({t.other_adjusted.map((o) => new Date(`${o.date}T12:00:00`).toLocaleDateString("es-ES", { weekday: "short", day: "numeric" })).join(", ")}). Si mejoras, se retirarán los ajustes.</div>}
      {t.session_id && <button className="qv-btn-primary" style={{ width: "100%", padding: 16, display: "flex", justifyContent: "center", gap: 8 }} onClick={open} data-testid="today-open-session">{t.next_session_date && t.next_session_date !== c.local_date ? `Ver mi próxima sesión (${new Date(`${t.next_session_date}T12:00:00`).toLocaleDateString("es-ES", { weekday: "long", day: "numeric" })})` : "Ver mi sesión de hoy"} <ArrowRight size={16} /></button>}
      <div style={{ fontSize: 11, color: "#737373", marginTop: 12 }} data-testid="today-disclaimer">{t.disclaimer}</div>
      {s && <SessionView session={s} onClose={() => setS(null)} onUpdated={setS} />}
    </div>
  );
};
